import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import * as CongNoKHConstant from './constants'
import * as CongNoKHAction from './actions'
import { storedb } from '../client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate } from "../../lib/common";
import Moment from "react-moment";

class CongNoKH extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    congNoKHListRequest: PropTypes.func,
    congNoKHExportXlsRequest: PropTypes.func,
    congNoKH: PropTypes.shape({
      list: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month').format('YYYYMMDD'),
      denNgay: currentDate().format('YYYYMMDD'),
      item: {},
      list: [],
      total_record: 0,
      tong_soLuong: 0,
      page: 1,
      per_page: 20,
      maKhachHang: ""
    };
  }
  getParams = (callback) => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { maKH, tuNgay, denNgay } = params;
      this.setState({ maKhachHang: maKH, tuNgay, denNgay}, callback)
    }
  }
  viewCongNoHd = (e, maHD) => {
    e.preventDefault()
    const url = `/congnohd/${maHD}`
    this.props.history.push(url);
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    const { congNoKHListRequest } = this.props

    var requestData = {
      storeId: this.state.store_id,
      maKH: this.state.maKhachHang,
      fromDate: this.state.tuNgay,
      toDate: this.state.denNgay,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return congNoKHListRequest(requestData)
  }
  exportXls = () => {
    const { congNoKHExportXlsRequest } = this.props

    var requestData = {
      storeId: this.state.store_id,
      maKH: this.state.maKhachHang,
      fromDate: this.state.tuNgay,
      toDate: this.state.denNgay,
      page: 1,
      per_page: 5000
    };
    return congNoKHExportXlsRequest(requestData);
  }
  search = () => {
    if (this.props.congNoKH.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  initData = () => {
    this.fetchList();
  }
  componentDidMount() {
    this.getParams(this.initData)
  }
  componentWillReceiveProps(nextProps) {
   if (nextProps.congNoKH.type == CongNoKHConstant.CONG_NO_KH_LIST_SUCCESS) {
      let { list, item } = nextProps.congNoKH;
      this.setState(
        {
          page: item.page,
          per_page: item.per_page,
          total_record: item.total_record,
          totalRecord: item.total_record[0].countRecorde || 0,
          list: list
        }
      )
    }
    else if (nextProps.congNoKH.type == CongNoKHConstant.CONG_NO_KH_EXPORT_XLS_SUCCESS) {
      let { item } = nextProps.congNoKH;
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportCongNoKh';
      var fileName = "congnokhachhang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportCongNoKh";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    }
  }
  render() {
    const { list } = this.state
    const {
      handleSubmit,
      congNoKH: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <div className="w-100 mb-2 mt-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> In</Button>&nbsp;
              <Button size="md" color="success" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
             <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="130" className="text-center table-border-right">Mã đơn hàng</th>
                    <th scope="col" width="100" className="text-left table-border-right">Ngày hóa đơn</th>
                    <th scope="col" width="120" className="text-left table-border-right">Nhân viên KD</th>
                    <th scope="col" width="110" className="text-left table-border-right">Nơi xuất</th>
                    <th scope="col" width="110" className="text-right table-border-right">Tổng tiền	</th>
                    <th scope="col" width="100" className="text-right table-border-right">Đã thanh toán</th>
                    <th scope="col" width="100" className="text-right table-border-right">Còn nợ</th>
                    <th scope="col" width="100" className="text-left table-border-right">Ngày thanh toán</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="table-border-right">  <a href='#' onClick={(e) => this.viewCongNoHd(e, res.id)}>{res.MaDonHang}</a> </td>
                        <td className="text-center table-border-right">{res.NgayLap && <Moment format="HH:mm DD/MM">{`${res.NgayLap}`}</Moment>}</td>
                        <td className="text-left table-border-right">{res.tendaydu}</td>
                        <td className="text-left table-border-right">{res.NoiXuat}</td>
                        <td className="text-right text-danger table-border-right">{parseFloat(res.TongTien || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right table-border-right">{parseFloat(res.TienThangToan || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right table-border-right">{parseFloat(res.ConNo || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="table-border-right">{res.NgayThanhToan && <Moment format="HH:mm DD/MM">{`${res.NgayThanhToan}`}</Moment>}</td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                  <th scope="col" colSpan="4" className="text-right table-border-right">
                      Tổng
                    </th>
                    <th scope="col" className="text-right table-border-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].TongTien.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right table-border-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].TienThangToan.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right table-border-right">
                      <span className="text-success">
                        {this.state.total_record &&
                          this.state.total_record[0].ConNo.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right ">
                    </th>
                  </tr>
                </tfoot>
              </Table>
           
                 {this.state.totalRecord > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  congNoKH: state.congNoKH,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  congNoKHListRequest: CongNoKHAction.congNoKHListRequest,
  congNoKHExportXlsRequest: CongNoKHAction.congNoKHExportXlsRequest
})(CongNoKH)

const formed = reduxForm({
  form: 'congNoKH',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/CongNo/CongNoKH.js